import { render, staticRenderFns } from "./LegalFileDetail.vue?vue&type=template&id=73c1b844&scoped=true"
import script from "./LegalFileDetail.vue?vue&type=script&lang=js"
export * from "./LegalFileDetail.vue?vue&type=script&lang=js"
import style0 from "./LegalFileDetail.vue?vue&type=style&index=0&id=73c1b844&lang=scss&scoped=true"
import style1 from "./LegalFileDetail.vue?vue&type=style&index=1&id=73c1b844&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c1b844",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73c1b844')) {
      api.createRecord('73c1b844', component.options)
    } else {
      api.reload('73c1b844', component.options)
    }
    module.hot.accept("./LegalFileDetail.vue?vue&type=template&id=73c1b844&scoped=true", function () {
      api.rerender('73c1b844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/settlementUnit/LegalFileDetail.vue"
export default component.exports